import { atom } from 'recoil';

export const jobIdAtom = atom<string>({
    key: 'jobId',
    default: new URLSearchParams(window.location.search).get('tilbudsId') ?? ''
});
